import { createRouter, createWebHistory } from 'vue-router'
import { Layout } from '@/layout/index.js'
import orderDetailRoutes from '@/page/orderManagement/order/router.js'
import airOrderRoutes from '@/page/orderManagement/airOrder/router.js'
import topMenuRoutes from '@/layout/topMenuRoutes.js'
// 默认不需要权限的页面
export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/page/login/index.vue'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/page/errorPage/404.vue'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/page/errorPage/401.vue'),
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [{
      path: '/redirect/:path(.*)',
      component: () => import('@/page/redirect/index.vue')
    }]
  },
  ...orderDetailRoutes,
  ...airOrderRoutes,
  {
    path: '/home',
    component: Layout,
    meta: {
      title: '工作台',
      icon: 'House'
    },
    constant: true,
    alwaysShow: true,
    noDropdown: true,
    hidden: false,
    children: [{
      path: 'index',
      name: 'Index',
      meta: {
        title: '工作台',
        affix: true
      },
      component: () => import('@/page/home/index.vue')
    }]
  },
  ...topMenuRoutes,
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRouterMap
})


export function resetRouter() {
  const newRouter = createRouter({
    history: createWebHistory(),
    routes: constantRouterMap
  })
  router.matcher = newRouter.matcher 
}


export default router
